import { defineMessages } from 'react-intl-next';

export default defineMessages({
    emptyErrorNonFinal: {
        defaultMessage: 'Enter a response',
        description: 'Error text when textfield is empty.',
        id: 'help-centre-virtual-agent.conversation.input.empty-error-non-final',
    },
    inputPlaceholderNonFinal: {
        defaultMessage: 'Enter your response',
        description: 'Placeholder text for the input field in the conversation if they are in any active conversation',
        id: 'virtual-agent.conversation.input.placeholder.nonFinal',
    },
    newConversationPlaceholderNonFinal: {
        defaultMessage: 'Ask a question or search for information',
        description:
            'Placeholder text for the input field in the conversation if they are not in any active conversation',
        id: 'virtual-agent.conversation.input.new-conversation.placeholder.nonFinal',
    },
});
